import { LOAD_ALL_SITE, LOAD_SINGLE_SITE } from "./SiteList.saga";

export const loadAllSite = (payload) => ({
  type: LOAD_ALL_SITE.LOADING,
  payload,
});

export const loadSingleSite = (payload) => ({
  type: LOAD_SINGLE_SITE.LOADING,
  payload,
});
